const dashboard = [
    {
        "header": {
            "greeting": "Good Morning",
            "name": "Akash Menon",
        },
        "profile": {
            "shortlistedProfiles": 14,
            "recentlyViewed": 14,
            "profileVisitors": 14,
            "buyContacts": 3
        },
        "newMatches": {
            "count": 145,
            "matches": [
                {
                    "name": "Swathy Menon",
                    "age": "22 Yrs",
                    "height": "154cm",
                    "image": "Swathy Menon 22 Yrs 154cm"
                },
                {
                    "name": "Malu Menon",
                    "age": "22 Yrs",
                    "height": "154cm",
                    "image": "Malu Menon 22 Yrs 154cm"
                },
                {
                    "name": "Saranya",
                    "age": "24 Yrs",
                    "height": "157cm",
                    "image": "Saranya 24 Yrs 157cm"
                },
                {
                    "name": "Swathy Menon",
                    "age": "22 Yrs",
                    "height": "154cm",
                    "image": "Swathy Menon 22 Yrs 154cm"
                },
                {
                    "name": "Malu Menon",
                    "age": "22 Yrs",
                    "height": "154cm",
                    "image": "Malu Menon 22 Yrs 154cm"
                },
                {
                    "name": "Saranya",
                    "age": "24 Yrs",
                    "height": "157cm",
                    "image": "Saranya 24 Yrs 157cm"
                }
            ]
        },
        "discoverPartnerBy": {
            "location": "Location",
            "job": "Job",
            "education": "Education",
            "star": "Star"
        },
        "nearbyProfiles": {
            "profiles": [
                {
                    "distance": "3.2 km",
                    "name": "Saranya",
                    "age": "24 Yrs",
                    "height": "157cm",
                    "image": "Saranya 24 Yrs 157cm"
                },
                {
                    "distance": "5 km",
                    "name": "Aswathy T K",
                    "age": "25 Yrs",
                    "height": "152cm",
                    "image": "Aswathy T K 25 Yrs 152cm"
                },
                {
                    "distance": "6 km",
                    "name": "Swathy Menon",
                    "age": "22 Yrs",
                    "height": "154cm",
                    "image": "Swathy Menon 22 Yrs 154cm"
                },
                {
                    "distance": null,
                    "name": "Mal",
                    "age": "22 Yr",
                    "height": null,
                    "image": "Mal 22 Yr"
                }
            ]
        },
        "advertisement": {
            "brandName": "PREM JEWELLERS",
            "offer": "UP TO 20%",
            "tagLine": "The Great GOLD SALE",
            "viewDetails": "View Details >",
            "image": "B CT PREM JEWELLERS P0000"
        },
        "recentVisitors": {
            "viewAll": "view all",
            "visitors": [
                {
                    "name": "Aswathy T K",
                    "age": "25 Yrs",
                    "profile": "Single",
                    "profession": "Software Engineer",
                    "height": "152cm",
                    "location": "Kadavanthra, Ernakulam",
                    "image": "Aswathy T K 25 Yrs Single Software Engineer 152cm Kadavanthra Ernakulam"
                },
                {
                    "name": "Ganga Sivan",
                    "age": "25 Yrs",
                    "profile": "Single",
                    "profession": "Software Engineer",
                    "height": "157cm",
                    "location": "Ettumanoor, Kottayam",
                    "image": "Ganga Sivan 25 Yrs Single Software Engineer 157cm Ettumanoor Kottayam"
                },
                {
                    "name": "Abhirami KS",
                    "age": "25 Yrs",
                    "profile": "Single",
                    "profession": "Software Engineer",
                    "height": "162cm",
                    "location": "Erattupetta, Kottayam",
                    "image": "Abhirami KS 25 Yrs Single Software Engineer 162cm Erattupetta Kottayam"
                },
                {
                    "name": "Lekshmi Sundar",
                    "age": "25 Yrs",
                    "profile": "Single",
                    "profession": "Software Engineer",
                    "height": "168cm",
                    "location": "Adminali, Idukki",
                    "image": "Lekshmi Sundar 25 Yrs Single Software Engineer 168cm Adminali Idukki"
                }
            ]
        },
        "todayMatches": {
            "todayMatches": "Today's Matches",
            "topViewed": "Top Viewed",
            "newJoine": "New Joine"
    },
        "recommendedProfiles": {
            "title": "Recommented Profiles for Today",
            "profiles": [
                {
                    "name": "Arya",
                    "image": "Arya"
                },
                {
                    "name": "Ganga",
                    "image": "Ganga"
                },
                {
                    "name": "Karthika",
                    "image": "Karthika"
                },
                {
                    "name": "Lekshmi",
                    "image": "Lekshmi"
                },
                {
                    "name": "Indu",
                    "image": "Indu"
                }
            ]
        },
        "advertisement" : {
            "add" : 'https://static.vecteezy.com/system/resources/previews/000/962/809/original/abstract-gradient-background-with-colorful-and-modern-style-vector.jpg',
            "action" : "whatsapp",
            "link" : "https://google.com/"
        }
    }
]

export {dashboard}